import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { PipesModule } from '@mmx/pipes'
import { Estimate, EstimateBalanceWorkflowStatus, estimateStatusText } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { BalanceWorkflowStatusPipe } from '../estimate-balance/pipes/balance-workflow-status.pipe'

@Component({
  selector: 'mmx-estimate-status-summary',
  templateUrl: './estimate-status-summary.component.html',
  imports: [
    CommonModule,
    PipesModule,
    FlexLayoutModule,
    TranslateModule,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstimateStatusSummaryComponent {
  @Input() estimateStatus: EstimateBalanceWorkflowStatus | null = null
  /** The legacy estimator calls a confirmed estimate "Finalized"; every other word matches. */
  @Input() legacyLabels = false

  private readonly workflowStatus = new BalanceWorkflowStatusPipe()

  get labelKey(): string {
    return this.legacyLabels && this.estimateStatus === EstimateBalanceWorkflowStatus.CONFIRMED
      ? estimateStatusText(Estimate.STATUS.CONFIRMED)
      : this.workflowStatus.transform(this.estimateStatus)
  }
}
